/**
 * @type {Object}
 * @property {array}  data  Supplier data
 */
 const initialState = {
    creditNoteData: []
};

/**
 * 
 * @param {Object} state    Initial state of store 
 * @param {Object} action   action data
 * @returns {Object} newState 
 */
const reducerCreditNotePurchase = (state = initialState, action) => {
    const newState = { ...state }
    switch (action.type) {

        case 'FETCH_CREDIT_NOTE_DATA':
            var { data } = action;
            newState.creditNoteData = data;
            break;

        default:
            break;
    }
    return newState;
}

export default reducerCreditNotePurchase;